<template>
    <div id="paperdispatch">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'paperdispatch'
}
</script>

<style scoped>

</style>